import type { VoiceTypeKey } from '@/src/dal/user-dal'

import type { PostPaymentOption } from './types'

export function getVoiceTypeOptions(
  t: (key: string, options?: { defaultValue: string }) => string,
): PostPaymentOption<VoiceTypeKey>[] {
  return [
    {
      key: 'unknown',
      label: t('onboarding:post_payment.voice_types.unknown'),
    },
    {
      key: 'soprano',
      label: t('onboarding:post_payment.voice_types.soprano'),
    },
    {
      key: 'mezzoSoprano',
      label: t('onboarding:post_payment.voice_types.mezzo_soprano'),
    },
    {
      key: 'alto',
      label: t('onboarding:post_payment.voice_types.alto_contralto'),
    },
    {
      key: 'tenor',
      label: t('onboarding:post_payment.voice_types.tenor'),
    },
    {
      key: 'baritone',
      label: t('onboarding:post_payment.voice_types.baritone'),
    },
    {
      key: 'bass',
      label: t('onboarding:post_payment.voice_types.bass'),
    },
  ]
}
